export const localStorageServices = {
  setItem: (key: string, value: string) => localStorage.setItem(key, value),
  getItem: (key: string) => localStorage.getItem(key),
  removeItem: (key: string) => localStorage.removeItem(key),
  clearAuthData: () => {

    const wasInitialized = localStorage.getItem("appInitialized");
    const userChecked = localStorage.getItem("userChecked");
 
    
   
    localStorage.removeItem("token");
    localStorage.removeItem("idToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userLoggedIn");
    localStorage.removeItem("userRegistered");
    

    sessionStorage.removeItem("isExistingUser");
    

    localStorage.removeItem("intendedPath");

    localStorage.removeItem("fromQR");
    sessionStorage.removeItem("qrFacilityId");
    
  
    if (wasInitialized) {
      localStorage.setItem("appInitialized", "true"); 
    }
    
    if (userChecked) {
      localStorage.setItem("userChecked", userChecked);
    }
  },
};